<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  name:"lineBig",
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: [
    'maj',
    ],
  data(){
    return {   
      options: {
          elements: {
              line: {
                  tension: 0
              }
          },
        tooltips: {
          enabled: true,
          mode: 'point',
          callbacks: {
            label: (tooltipItem, data) => {
              const datasetLabel = data.datasets?.[tooltipItem.datasetIndex]?.label || '';
              const y = Number(tooltipItem.yLabel);
              const formatted = Number.isFinite(y) ? y.toLocaleString() : tooltipItem.yLabel;
              return datasetLabel ? `${datasetLabel}: ${formatted}` : `${formatted}`;
            }
          }
        },
            responsive: true,
            maintainAspectRatio: false,
            
            legend: {
              display: false,
              labels: {
                      // fontSize: 0,
                      fontColor: 'green'
                  }              
            },
            scales: {
              xAxes: [{
                  type: 'time',
                  display: true,
                  gridLines: {
                      display: true,
                      drawBorder: true
                  },
                  time: {
                      tooltipFormat:'DD/MM/YYYY',
                      displayFormats: {
                          hour: 'HH',
                          day: 'DD/MM',
                          week: 'DD/MM/YYYY',
                          month: 'DD/MM',
                          year: 'YYYY',
                        quarter:'MM/YYYY'
                      },
                      unit: 'day'
                  },
                  scaleLabel:{
                      display: false,
                      labelString:'Date'
                  },
                  ticks: {
                      autoSkip: true,
                      autoSkipPadding: 50,
                      minRotation: 0,
                      maxRotation: 0
                  }
              }],
              yAxes: [{
                position: 'right',
                ticks: {
                    maxTicksLimit: 6,
                    beginAtZero : false,
                    callback: (value) => {
                      // value peut être un nombre ou une string -> on force en nombre
                      const n = Number(value);
                      if (!Number.isFinite(n)) return value;

                      return n.toLocaleString();
                    }
                },
                gridLines: {
                    display:false,
                    drawBorder:true
                }
              }]
            }            
          }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    'maj' () {
      this.renderChart(this.chartData, this.options);
    } 
  }
}
</script>

<style>
</style>
